import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {submitReferralConfig, updateReferralConfig} from "../../../services/referral/referral_config";
import Validator from "../../../helper/validator/Validator";
import persianNumberFormat from "../../../helper/PersianNumberFormat";

export function ReferralConfigForm({referralConfig, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("")
  const [type, setType] = useState("purchase_cashback")
  const [value, setValue] = useState()
  const [referrerShare, setReferrerShare] = useState(100)
  const [refereeShare, setRefereeShare] = useState(0)
  const [isDefault, setIsDefault] = useState(false)
  const [status, setStatus] = useState(true)


  useEffect(() => {
    setId(referralConfig?.id ?? null);
    setTitle(referralConfig?.title ?? "")
    setDescription(referralConfig?.description ?? "")
    setType(referralConfig?.type ?? "purchase_cashback")
    setValue(referralConfig?.value ?? "")
    setReferrerShare(referralConfig?.referrer_share ?? 100)
    setRefereeShare(referralConfig?.referee_share ?? 0)
    setIsDefault(referralConfig?.is_default ?? false)
    setStatus(referralConfig?.status === 'enable' ?? false);
  }, [referralConfig]);

  const save = async () => {
    const data = {
      id: id,
      title: title,
      description: description,
      type: type,
      value: parseInt(value),
      referrer_share: parseInt(referrerShare),
      referee_share: parseInt(refereeShare),
      is_default: isDefault,
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitReferralConfig(data);
    } else {
      result = await updateReferralConfig(data);
    }

    if (result.status === 201 || result.status === 202) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  useEffect(() => {
    if (type === "purchase_cashback") {
      if (referrerShare > 100) {
        setReferrerShare(100)
        setRefereeShare(0)
      } else if (referrerShare < 0) {
        setReferrerShare(0)
        setRefereeShare(100)
      } else if (refereeShare > 100) {
        setReferrerShare(0)
        setRefereeShare(100)
      } else if (refereeShare < 0) {
        setReferrerShare(100)
        setRefereeShare(0)
      }
    }
  }, [referrerShare, refereeShare]);

  useEffect(() => {
    if (type === "register_bonus") {
      setValue(0)
      setReferrerShare(0)
      setRefereeShare(0)
    }
  }, [type]);

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col mt-2 gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={description}
                   label={Dict('description')}
                   placeholder={Dict('description')}
                   onChange={(e) => {
                     setDescription(e.target.value)
                   }}
            />
          </div>

          {!id ?
            <div className="flex flex-col w-full mb-4">
              <Select variant="static" className="rtl" style={{label: {left: ""}}}
                      label={Dict('referral_config_type')}
                      value={type}
                      onChange={(val) => setType(val)}>
                <Option value="purchase_cashback">کش‌بک خرید</Option>
                <Option value="register_bonus">پاداش ثبت نام</Option>
              </Select>
              <Validator state={type} rules="required"/>
            </div>
            :
            <div className="flex flex-row w-full mb-4">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('referral_config_type')}: `}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {`${type === "purchase_cashback" ? "کش‌بک خرید" : type === "register_bonus" ? "پاداش ثبت نام" : type}`}
                </Typography>
              </div>
            </div>
          }

          {type === "purchase_cashback" &&
            <>
              <div className="mb-4">
                <Input variant="standard"
                       value={value}
                       label={Dict('referral_config_cashback_percentage')}
                       placeholder={Dict('referral_config_cashback_percentage')}
                       onChange={(e) => {
                         setValue(e.target.value)
                       }}
                />
              </div>

              <div className="mb-4">
                <Input variant="standard"
                       value={referrerShare}
                       type="number"
                       min="0"
                       max="100"
                       label={Dict('referral_config_referrer_share')}
                       placeholder={Dict('referral_config_referrer_share')}
                       onChange={(e) => {
                         setReferrerShare(e.target.value)
                         setRefereeShare(100 - e.target.value)
                       }}
                />
              </div>

              <div className="mb-4">
                <Input variant="standard"
                       value={refereeShare}
                       type="number"
                       min="0"
                       max="100"
                       label={Dict('referral_config_referee_share')}
                       placeholder={Dict('referral_config_referee_share')}
                       onChange={(e) => {
                         setRefereeShare(e.target.value)
                         setReferrerShare(100 - e.target.value)
                       }}
                />
              </div>
            </>
          }

          {type === "register_bonus" &&
            <>
              <div className="mb-4">
                <Input variant="standard"
                       value={value}
                       label={Dict('referral_config_bonus')}
                       placeholder={Dict('referral_config_bonus')}
                       onChange={(e) => {
                         setValue(e.target.value)
                         setReferrerShare(e.target.value)
                         setRefereeShare(0)
                       }}
                />
                {(value && value > 0) &&
                  <Typography color='blue-gray' className='mt-1'>
                    {`${persianNumberFormat(value, true)} ریال`}
                  </Typography>
                }
              </div>

              <div className="mb-4">
                <Input variant="standard"
                       value={referrerShare}
                       type="number"
                       label={Dict('referral_config_referrer_share')}
                       placeholder={Dict('referral_config_referrer_share')}
                       onChange={(e) => {
                         setReferrerShare(e.target.value)
                         setRefereeShare(value - e.target.value)
                       }}
                />
                {referrerShare && referrerShare > 0 &&
                  <Typography color='blue-gray' className='mt-1'>
                    {`${persianNumberFormat(referrerShare, true)} ریال`}
                  </Typography>
                }
              </div>

              <div className="mb-4">
                <Input variant="standard"
                       value={refereeShare}
                       type="number"
                       label={Dict('referral_config_referee_share')}
                       placeholder={Dict('referral_config_referee_share')}
                       onChange={(e) => {
                         setRefereeShare(e.target.value)
                         setReferrerShare(value - e.target.value)
                       }}
                />
                {refereeShare && refereeShare > 0 &&
                  <Typography color='blue-gray' className='mt-1'>
                    {`${persianNumberFormat(refereeShare, true)} ریال`}
                  </Typography>
                }
              </div>

            </>

          }


          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  پیش‌فرض (تنها یک مورد پیش‌فرض می‌ماند و مورد پیش قبلی حذف میگردد.)
                </Typography>
              }
              checked={isDefault}
              onChange={(e) => {
                setIsDefault(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}